import React from "react";
import { buildFileUrl, getFileAsset } from "@sanity/asset-utils";
import sanityLocation from "src/utils/sanityLocation";
import type { PortableTextMarkComponentProps } from "@portabletext/react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props = PortableTextMarkComponentProps<any>;

const LinkToFile: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  children
}) => {
  const fileAsset = getFileAsset(value.file.asset, sanityLocation);
  const fileURL = buildFileUrl(fileAsset, sanityLocation);
  if (value.forceDownload)
    return (
      <a href={`${fileURL}?dl=`} download>
        {children}
      </a>
    );
  else return <a href={fileURL}>{children}</a>;
};

export default LinkToFile;
